import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import keyDown from '@mailobj-browser/front/js/events/types/keyDown.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { run } from '#utilities/js/hotkey/hotkey.js'

const iframes = new WeakMap()

const onKeyDown = object(listener, {
  type: keyDown,
  passive,
  task: async (
    document,
    event
  ) => {
    const { ownerDocument } = iframes.get(document)
    const { body } = ownerDocument

    await run(ownerDocument, body, event)
  }
})

const onLoad = object(listener, {
  type: load,
  passive,
  once,
  task: (
    iframe
  ) => {
    const { contentWindow } = iframe
    const { document } = contentWindow

    iframes.set(document, iframe)
    onKeyDown.listen(document)

    queueMicrotask(async () => {
      await removed(iframe)
      if (iframes.get(document) === iframe) {
        iframes.delete(document)
      }
    })
  }
})

export default iframe => {
  const { contentWindow } = iframe

  if (contentWindow) {
    return onLoad.task(iframe)
  }

  onLoad.listen(iframe)
}